import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const fieldTypeMap = {
    basic: {
        display: "基本信息",
        range: ["BASIC", "CONTRACT", "WORK", "CLOTHES", "EMER_CONTR", "CHILD"],
    },
    other: {
        display: "其他信息",
        range: ["JOB_TITLE", "DUTY", "RANK", "SPEC_QUAL", "EDU_EXP", "WORK_EXP", "CERT", "REWARD", "ATTACH"],
    },
};

export const SELF_READ_EDITABLE_ITEMS = ["rotationScore", "rotationReview", "rotationReason", "secondmentReview"];

const initState = {
    fieldType: "basic", // bar选择的类型
    groupsLoading: false, // 字段组加载
    fieldGroups: [], // 显示的字段组
    fieldItems: null, // 显示的字段组的字段
    allFieldItems: null, // 过滤用
    searchValue: "", // 过滤信息
    searchMode: false, // 搜索模式，点击搜索后变成true
    setTableLoading: () => {}, // 设置当前编辑table loading

    editRoles: [], // 可编辑的角色列表

    editField: null, // 增加新的字段
    editFieldVisible: false, // 编辑字段 drawer 可见
    editFieldSaving: false, // 字段保存

    sortFields: null, // 字段排序数据
    sortSaving: false, // 字段排序保存

    editPermFieldsVisible: false, // 批量编辑的字段权限可见
    editPermFields: null, // 批量编辑的字段权限
    editPermGroup: null, // 批量编辑更改字段组属性
    editPermFieldsSaving: false, // 批量编辑字段保存

    attendanceSubmitted: false, // 提交了考勤同步
    applyAttendanceModalVisible: false, // 申请考勤同步modal
    editConfirmLoading: false, // modal提交loading
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,

    fieldTypeMap,
};
export default viewModel;
